import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useNotification } from "../NotificationContext";
import api from "@/api";

const AddHolding = ({ onRefresh }) => {
  const { id: accountId } = useParams();
  const navigate = useNavigate();
  const { showSuccess, showError } = useNotification();

  const [formData, setFormData] = useState({
    ticker: "",
    company_name: "",
    industry: "",
    quantity: "",
    entry_price: "",
    entry_date: new Date().toISOString().split("T")[0],
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !formData.ticker ||
      !formData.quantity ||
      !formData.entry_price ||
      !formData.entry_date
    ) {
      showError("Please fill in all required fields");
      return;
    }

    try {
      setLoading(true);

      const holdingData = {
        account_id: accountId,
        ticker: formData.ticker.toUpperCase(),
        company_name: formData.company_name,
        industry: formData.industry,
        quantity: parseFloat(formData.quantity),
        entry_price: parseFloat(formData.entry_price),
        entry_date: new Date(formData.entry_date).toISOString(),
      };

      await api.post("/holdings", holdingData);
      onRefresh();
      showSuccess(`${formData.ticker} added successfully`);
      navigate(`/account/${accountId}`);
    } catch (error) {
      console.error("Error creating holding:", error);
      showError("Error creating holding");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <div>
          <button
            className="btn btn-secondary"
            onClick={() => navigate(`/account/${accountId}`)}
            style={{ marginBottom: "1rem" }}
          >
            ← Back to Account
          </button>
          <h1 className="dashboard-title">Add New Holding</h1>
        </div>
      </div>

      <div className="form-container" style={{ maxWidth: "600px" }}>
        <form onSubmit={handleSubmit}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "1rem",
            }}
          >
            <div className="form-group">
              <label className="form-label">Ticker *</label>
              <input
                type="text"
                className="form-input"
                placeholder="e.g., AAPL"
                value={formData.ticker}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    ticker: e.target.value.toUpperCase(),
                  })
                }
              />
            </div>

            <div className="form-group">
              <label className="form-label">Entry Date *</label>
              <input
                type="date"
                className="form-input"
                value={formData.entry_date}
                onChange={(e) =>
                  setFormData({ ...formData, entry_date: e.target.value })
                }
              />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Company Name</label>
            <input
              type="text"
              className="form-input"
              placeholder="e.g., Apple Inc."
              value={formData.company_name}
              onChange={(e) =>
                setFormData({ ...formData, company_name: e.target.value })
              }
            />
          </div>

          <div className="form-group">
            <label className="form-label">Industry</label>
            <input
              type="text"
              className="form-input"
              placeholder="e.g., Technology"
              value={formData.industry}
              onChange={(e) =>
                setFormData({ ...formData, industry: e.target.value })
              }
            />
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "1rem",
            }}
          >
            <div className="form-group">
              <label className="form-label">Quantity *</label>
              <input
                type="number"
                step="0.01"
                className="form-input"
                placeholder="100"
                value={formData.quantity}
                onChange={(e) =>
                  setFormData({ ...formData, quantity: e.target.value })
                }
              />
            </div>

            <div className="form-group">
              <label className="form-label">Entry Price *</label>
              <input
                type="number"
                step="0.01"
                className="form-input"
                placeholder="150.00"
                value={formData.entry_price}
                onChange={(e) =>
                  setFormData({ ...formData, entry_price: e.target.value })
                }
              />
            </div>
          </div>

          <div className="form-actions">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => navigate(`/account/${accountId}`)}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? "Adding..." : "Add Holding"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddHolding;
